import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

// URL del formulario de HubSpot
const HUBSPOT_FORM_URL =
  'https://tdgrm.share.hsforms.com/2o1NiMr-WRiWEniTAEpv4KQ';

/**
 * PageHeader Component
 *
 * Props:
 * - title: string (required) - Texto principal
 * - subtitle: string (optional) - Subtítulo o introducción
 * - imageSrc: string (optional) - URL de la imagen a mostrar debajo del botón
 * - className: string (optional) - Clases adicionales
 */
export default function PageHeader({
  title,
  subtitle,
  imageSrc,
  className = '',
}) {
  // Detectar idioma para texto del botón
  const isEnglish =
    typeof navigator !== 'undefined' && navigator.language.startsWith('en');
  const buttonText = isEnglish ? 'Book Demo' : 'Reservar Demo';

  // Click → abrir HubSpot en nueva pestaña
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.open(HUBSPOT_FORM_URL, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <header className={`w-full bg-[#F5F5F5] ${className}`}>
      <div className="mt-20 max-w-7xl mx-auto py-8 px-4 text-center">
        <h1 className="text-4xl font-extrabold sm:text-5xl text-[#000000]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 text-lg font-normal text-[#000000]">{subtitle}</p>
        )}

        {/* Botón personalizado */}
        <button
          onClick={handleClick}
          className="mt-10 inline-flex items-center px-8 py-3 rounded-2xl font-semibold bg-[#ff2300] text-white"
        >
          <FontAwesomeIcon icon={faWandMagicSparkles} className="mr-2" />
          {buttonText}
        </button>

        {imageSrc && (
          <img
            src={imageSrc}
            alt=""
            className="mt-6 mx-auto w-3/4 max-w-full h-auto rounded-lg"
          />
        )}
      </div>
    </header>
  );
}
